import uk from 'i18n/uk.json';

export default uk;
